export default __webpack_public_path__ + "static/media/last.f00f4291.svg";